import React from "react";
import { Layout } from "antd";
import AnalysisForm from "../AnalysisForm";
import Dashboard from "../Dashboard";
import WebsiteIndexEntryTabs from "../../deepAnalysis/websiteIndexEntry/WebsiteIndexEntryTabs";


export default function DashboardPage() {
    return (
        <Layout.Content className="general-layout-content">
            <AnalysisForm />
            <WebsiteIndexEntryTabs>
                <Dashboard />
            </WebsiteIndexEntryTabs>
        </Layout.Content>
    );
}
